function openCustomPopup() {
    document.querySelector('.custom-size-popup').style.display = 'flex';

    const selectedColorLabel = document.querySelector('.product-form__input--pill input[type=radio]:checked');
    const selectedColor = selectedColorLabel ? selectedColorLabel.value.trim() : null;
    if (selectedColor) {
      const colorSelect = document.getElementById('custom-color');
      const colorInput = document.getElementById('custom-color-input');
      if (colorSelect) {
        const matchingOption = Array.from(colorSelect.options).find(option => 
          option.value.toLowerCase() === selectedColor.toLowerCase()
        );
      if (matchingOption) {
          colorSelect.value = matchingOption.value;
          colorInput.value = matchingOption.text;
        }
      }
    }
    
    if (!window.countryCodesLoaded) {
      loadCountryCodes();
    }
  }

  function closeCustomPopup() {
    document.querySelector('.custom-size-popup').style.display = 'none';
  }

  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('CustomSizeForm');
    if (form) {
      if (localStorage.getItem('custom_order_submitted') === 'true') {
        localStorage.removeItem('custom_order_submitted');
        
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('contact_posted')) {
          showNotification('success', window.customOrderStrings.successMessage);
        } else if (urlParams.has('form_error')) {
          showNotification('error', window.customOrderStrings.errorMessage);
        }
      }

      loadCountryCodes();

      form.addEventListener('submit', function(event) {
        let isValid = true;
        let firstInvalidInput = null;

        document.querySelectorAll('.form-field').forEach(field => {
          field.classList.remove('error');
          const errorMsg = field.querySelector('.error-message');
          if (errorMsg) errorMsg.remove();
        });

        const bodyField = document.getElementById('contact-body');
        let bodyContent = `${window.customOrderStrings.detailsPrefix} ${document.querySelector('input[name="contact[Product]"]').value}\n\n`;
        
        const processedFields = new Set();
        
        form.querySelectorAll('.form-field input, .form-field textarea, .form-field select').forEach(input => {
          if (input.type === 'hidden' && input.id !== 'custom-color') {
            return;
          }
          
          const labelElement = input.closest('.form-field').querySelector('label');
          if (!labelElement) return;
          
          const labelText = labelElement.textContent
            .trim()
            .replace(/\s*\*\s*$/, '')
            .replace(/\s*\([^)]*\)\s*\*?/g, '');
          
          if (processedFields.has(labelText)) {
            return;
          }
          
          let value = input.value.trim();
          
          if (labelText.includes('Phone') && input.id === 'custom-phone') {
            const countryCodeSelect = document.getElementById('country-code-select');
            if (countryCodeSelect && countryCodeSelect.value) {
              const phoneNumber = document.getElementById('custom-phone').value.trim();
              if (phoneNumber) {
                value = `${countryCodeSelect.value} ${phoneNumber}`;
                processedFields.add(labelText);
                bodyContent += `${labelText}: ${value}\n`;
              }
              return;
            }
          }
          
          if (value) {
            processedFields.add(labelText);
            
            const measurementFields = ['Height', 'Weight', 'Chest', 'Chest height', 'Waist', 'Waist height', 'Hip', 'Bicep', 'Sleeve length', 'Shoulder width'];
            const isMeasurementField = measurementFields.some(field => labelText.includes(field));
            
            let unit = '';
            if (isMeasurementField) {
              if (labelText.includes('Weight')) {
                unit = window.customOrderStrings.weightUnit || 'kg';
              } else {
                unit = window.customOrderStrings.sizeUnit || 'cm';
              }
            } else if (labelText.includes(window.customOrderStrings.specialLabel)) {
              unit = ''; 
            }
            
            bodyContent += `${labelText}: ${value}${unit ? ' ' + unit : ''}\n`;
          }
        });
        
        bodyField.value = bodyContent;

        form.querySelectorAll('input[required], textarea[required]').forEach(input => {
          const fieldWrapper = input.closest('.form-field') || input.closest('.fields');
          const value = input.value.trim();

          if (!value) {
            isValid = false;
            if (!firstInvalidInput) firstInvalidInput = input;
            showFieldError(fieldWrapper, window.customOrderStrings.requiredFieldError);
            return;
          }

          if (input.name.includes('Height') || input.name.includes('Weight') || 
              input.name.includes('Chest') || input.name.includes('Waist') || 
              input.name.includes('Hip') || input.name.includes('Bicep') || 
              input.name.includes('length') || input.name.includes('width')) {
            
            const numericValue = parseFloat(value);
            if (isNaN(numericValue) || numericValue <= 0) {
              isValid = false;
              if (!firstInvalidInput) firstInvalidInput = input;
              showFieldError(fieldWrapper, window.customOrderStrings.numericFieldError);
              return;
            }
          }
        });
        if (!isValid) {
          event.preventDefault();
          if (firstInvalidInput) firstInvalidInput.focus();
          showFormNotification('error', window.customOrderStrings.formErrorMessage);
        } else {
          localStorage.setItem('custom_order_submitted', 'true');
        }
      });
    }
  });

  function showFieldError(wrapper, message) {
    wrapper.classList.add('error');
    const errorDiv = document.createElement('div');
    errorDiv.className = 'error-message';
    errorDiv.style.color = 'red';
    errorDiv.style.fontSize = '12px';
    errorDiv.style.marginTop = '4px';
    errorDiv.textContent = message;
    wrapper.appendChild(errorDiv);
  }
  
  function updateVariantInput(variantTitle) {
    document.querySelector('input[name="contact[Variant]"]').value = variantTitle;
  }

  function showFormNotification(type, message) {
    const notificationDiv = document.getElementById('custom-form-notification');
    const messageDiv = notificationDiv.querySelector('.notification-message');
    
    notificationDiv.style.display = 'block';
    notificationDiv.className = `custom-form-notification notification-${type}`;
    messageDiv.textContent = message;
  }

  function showNotification(type, message) {
    const variantPicker = document.querySelector('.product-form__input--pill.variant-Size');
    
    const buyButtonContainer = document.querySelector('.product-form__submit');
    
    const notification = document.createElement('div');
    notification.className = `simple-notification notification-${type}`;
    notification.textContent = message;
    notification.style.fontSize = '14px';
    notification.style.marginTop = '15px';
    notification.style.marginBottom = '10px';
    
    if (type === 'success') {
      notification.style.color = '#2E7D32';
    } else {
      notification.style.color = '#C62828';
    }
    
    if (variantPicker) {
      variantPicker.insertAdjacentElement('afterend', notification);
    } 
    else if (buyButtonContainer) {
      buyButtonContainer.insertAdjacentElement('beforebegin', notification);
    }
    
    setTimeout(() => {
      notification.style.opacity = '0';
      notification.style.transition = 'opacity 0.5s';
      
      setTimeout(() => {
        notification.remove();
      }, 500);
    }, 5000);
  }

  function loadCountryCodes() {
    window.countryCodesLoaded = false;
    
    fetch('https://restcountries.com/v3.1/all')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        const countryCodesSelect = document.getElementById('country-code-select');
        const countryDropdown = document.getElementById('country-code-dropdown');
        const countryInput = document.getElementById('country-code-input');
        const dropdownOptions = countryDropdown ? countryDropdown.querySelector('.dropdown-options') : null;
        
        if (countryCodesSelect && dropdownOptions) {
          const sortedCountries = data.sort((a, b) => {
            const nameA = a.name.common || '';
            const nameB = b.name.common || '';
            return nameA.localeCompare(nameB);
          });
          
          countryCodesSelect.innerHTML = '';
          dropdownOptions.innerHTML = '';
          
          sortedCountries.forEach(country => {
            if (country.idd && country.idd.root) {
              const callingCode = country.idd.root + (country.idd.suffixes && country.idd.suffixes[0] ? country.idd.suffixes[0] : '');
              const option = document.createElement('option');
              option.value = callingCode;
              option.textContent = `${country.name.common} (${callingCode})`;
              countryCodesSelect.appendChild(option);
              
              const listItem = document.createElement('li');
              listItem.setAttribute('data-value', callingCode);
              listItem.textContent = `${country.flag} ${callingCode}`;
              dropdownOptions.appendChild(listItem);
            }
          });
          
          const defaultCountry = 'US';
          const defaultOption = Array.from(countryCodesSelect.options).find(option => 
            option.textContent.includes(defaultCountry)
          );
          
          if (defaultOption) {
            countryCodesSelect.value = defaultOption.value;
            if (countryInput) {
              countryInput.value = defaultOption.value;
            }
          }
          
          dropdownOptions.querySelectorAll('li').forEach(option => {
            option.addEventListener('click', function() {
              const value = this.getAttribute('data-value');
              countryInput.value = value;
              countryCodesSelect.value = value;
              countryDropdown.classList.remove('open');
              dropdownOptions.classList.add('hidden');
              updatePhoneInputFormat();
            });
          });
          
          if (countryInput) {
            countryInput.addEventListener('click', function() {
              countryDropdown.classList.toggle('open');
              dropdownOptions.classList.toggle('hidden');
            });
            
            document.addEventListener('click', function(event) {
              if (!countryDropdown.contains(event.target)) {
                countryDropdown.classList.remove('open');
                dropdownOptions.classList.add('hidden');
              }
            });
          }
          
          updatePhoneInputFormat();
          
          window.countryCodesLoaded = true;
        }
      })
      .catch(error => {
        console.error('Error fetching country data:', error);
      });
  }

  document.addEventListener('DOMContentLoaded', function() {
    const colorDropdown = document.getElementById('color-dropdown');
    const colorInput = document.getElementById('custom-color-input');
    const colorHiddenInput = document.getElementById('custom-color');
    const colorOptions = colorDropdown ? colorDropdown.querySelector('.dropdown-options') : null;
    
    if (colorDropdown && colorInput && colorOptions) {
      colorInput.addEventListener('click', function() {
        colorDropdown.classList.toggle('open');
        colorOptions.classList.toggle('hidden');
      });
      
      document.addEventListener('click', function(event) {
        if (!colorDropdown.contains(event.target)) {
          colorDropdown.classList.remove('open');
          colorOptions.classList.add('hidden');
        }
      });
      
      colorOptions.querySelectorAll('li').forEach(option => {
        option.addEventListener('click', function() {
          const value = this.getAttribute('data-value');
          colorInput.value = value;
          colorHiddenInput.value = value;
          colorDropdown.classList.remove('open');
          colorOptions.classList.add('hidden');
        });
      });
    }
  });
  
  function updatePhoneInputFormat() {
    const countryCodeSelect = document.getElementById('country-code-select');
    const phoneInput = document.getElementById('custom-phone');
    
    if (countryCodeSelect && phoneInput) {
      const selectedCode = countryCodeSelect.value;
      phoneInput.placeholder = `${window.customOrderStrings.phoneNumberOnly || 'Phone number (without country code)'}`;
      
      const form = document.getElementById('CustomSizeForm');
      if (form && !form.hasAttribute('phone-listener-added')) {
        form.setAttribute('phone-listener-added', 'true');
        form.addEventListener('submit', function() {
          if (phoneInput.value) {
            const originalPhone = phoneInput.value.trim();
            const currentSelectedCode = countryCodeSelect.value;
            
            if (!originalPhone.startsWith(currentSelectedCode)) {
              phoneInput.value = `${currentSelectedCode} ${originalPhone}`;
            }
          }
        });
      }
    }
  }